import { IApi } from '../../api'
import { createAction } from '../types'

export const prefix = 'presence'

export const LIST_PRESENCE_REQUEST = `${prefix}/LIST_PRESENCE_REQUEST`
export const LIST_PRESENCE_SUCCESS = `${prefix}/LIST_PRESENCE_SUCCESS`
export const LIST_PRESENCE_FAILURE = `${prefix}/LIST_PRESENCE_FAILURE`

export interface IListPresenceParams {
  /**
   * Which seed this request is. The reducer only lets the *latest* seed's
   * response land — see `seedId` on the slice for the race this closes.
   */
  seedId: number
}

/**
 * Monotonic per tab. Two seeds can be in flight together (MainLayout's mount
 * fetch and the reconnect re-seed in webSocketMiddleware both dispatch this),
 * and the promise middleware carries no request identity of its own — it spreads
 * the same action fields onto REQUEST, SUCCESS and FAILURE — so the id has to be
 * stamped here for the reducer to tell the responses apart.
 */
let nextSeedId = 0

/**
 * Seed the online set.
 *
 * Fetched rather than pushed because `PRESENCE_CHANGED` only fires on a
 * transition: a tab that loads while everyone is already connected would
 * otherwise see an empty set and render the whole company as offline. Re-run
 * after a socket reconnect, since transitions during the outage are gone.
 */
export const listPresence = createAction(() => ({
  type: [LIST_PRESENCE_REQUEST, LIST_PRESENCE_SUCCESS, LIST_PRESENCE_FAILURE],
  promise: (api: IApi) => api.auth.listPresence(),
  params: { seedId: ++nextSeedId } satisfies IListPresenceParams,
}))
